import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const MPStaffRBAC = {
  pageID: '68a8bddedf4ff78c11f11409c8d9abd8',
  elementID: {
    ViewStaffList: '008ac6078dc11f112b36eb75db9c99f3',
    ExportStaff: 'fb91b5c8904138f08e12be7e79a3d764',
    BulkUploadStaff: '66aa3752a4f7da7cf2fbb0e9d8fe85a3',
    SingleAddStaff: 'fee1ffb313dc2c8db7f58c2acd170a89',
    SingleEditStaff: '8977af7c6cead24b650cb8849c38d862',
    TerminationRequest: '2ea8a8009cc44f0bc3cb9cbd9b60d981',
    RejoinRequest: '0c840c4aa16b85440e6189ecc17cab9e',
    EditAllStaffField: '0dd59600f79bc633ef24f91cd7076fd7',
    ChangeActiveStatus: '8aa62a4f0b651cd4c15297989aaf6df4',
    ChangeActiveRole: '7b0e1d5c47c6fa5c4496aa30343541ce',
    ViewStaffDetails: 'ec2339b73d3a609df69caeb5aae57faf',
  },
} as const
export const useRBACMPStaffPage = createUseRBAC(MPStaffRBAC.elementID)
export type UseRBACMPStaffPageType = ReturnType<typeof useRBACMPStaffPage>

export const MPStaffUpsertDetailsRBAC = {
  pageID: '0bd31c6b32a9f65565e01b1298683999',
  elementID: {
    ViewPage: '72c3934565ca40d884a5fb7907c937f7',
    UpsertPersonalInformation: '62a0ef7865fdfb51c8d1dcd89985cf5a',
    UpsertEmploymentInformation: 'ac71bfed8d83e942a47231f460251a34',
    UpsertSystemAndAccess: '9d6d44e1fe082c8d3d1f972c6a04b7e4',
    UpsertAssignmentAndWorkLocation: '185dfd7c4521aa45f7d44e9cb9b2fbf8',
    UpsertWorkAvailability: '32c576c51b0c42e6c65ccffe8a59f5ca',
    UpsertSkillAndQualification: 'c9924d288114c82af869388a4c050b09',
    UpsertStatusAndRiskFlag: '95f8be0b84f216f0917b9bf0a8e9634a',
    UpsertVehicleInformation: '6a5c4907e9cebd780db75249988ab8ca',
    UpsertPayrollBanking: 'dc431433612b8f0e401293986431a977',
    UpsertAllInformation: '83c9dd029ceab8f889e070b373e435f5',
    ViewPersonalInformation: 'fc3c078cc894ce0ba8ef3bf67fe95270',
    ViewEmploymentInformation: 'f9f46767b8a65f1da82685e1aad295d2',
    ViewSystemAndAccess: '08730f6c053da8c45306d3ec242bfeee',
    ViewAssignmentAndWorkLocation: 'a17996efb6782c4835ebd97869a2f47e',
    ViewWorkAvailability: '00f7a69d4d401faca76ad5f1f21555fc',
    ViewSkillAndQualification: 'b903a23e47275834080c2ece87468a3b',
    ViewStatusAndRiskFlag: '1cf1fa7fc383a8c993755d2f5c34f250',
    ViewVehicleInformation: 'd2647cb03685d3fb19126af29c3f173c',
    ViewPayrollBanking: '3d3305f86e5ac99d391e79cf11530e85',
    ViewAllInformation: 'd80d80f08c63bdfc7981a27ff1fe4657',
  },
} as const
export const useMPStaffUpsertDetailsRBAC = createUseRBAC(MPStaffUpsertDetailsRBAC.elementID)
export type UseMPStaffUpsertDetailsRBACType = ReturnType<typeof useMPStaffUpsertDetailsRBAC>

export const MPStaffBulkUploadRBAC = {
  pageID: 'e30da19e24e28f35bd367bee2931596c',
  elementID: {
    ViewBulkUpload: '805183771343c5ab2e4164e8d501567c',
  },
}
export const useRBACMPStaffBulkUploadPage = createUseRBAC(MPStaffBulkUploadRBAC.elementID)
export type UseRBACMPStaffBulkUploadPageType = ReturnType<typeof useRBACMPStaffPage>

export const MPHiringFunnelRBAC = {
  pageID: 'd987bc78d70165422db7d98cd018c862',
  elementID: {
    ViewHiringList: '106ebc484fdecbdebcf61047c0cab756',
    SingleAddHiring: 'b4d3bf68bfdf90124b39f9015848d7b0',
    BulkUploadHiringCapacity: '3d10dff1026c20ff272aa10ad0b62156',
    AssignPIC: '3770844223140793a785da411216d3c7',
    AddPrioritization: '9c122f190b236a330b84c980f79d8d06',
  },
} as const
export const useRBACMPHiringFunnelPage = createUseRBAC(MPHiringFunnelRBAC.elementID)
export type UseRBACMPHiringFunnelPageType = ReturnType<typeof useRBACMPHiringFunnelPage>

export const PrioritizationSettingRBAC = {
  pageID: '8e99217d72fb045cbc996eee4a16a311',
  elementID: {
    ViewPrioritizationList: '2eacc34ad53838c7db2ca491ba749a53',
    CreatePrioritization: '872a3065ee6120a67df6c42a0b6d3708',
    EditPrioritization: '93a19b5290e52f6370f41858369c6cf4',
    DeletePrioritization: 'd5465217ee6e8e4401597ec193daba5d',
  },
} as const
export const useRBACPrioritizationSettingPage = createUseRBAC(PrioritizationSettingRBAC.elementID)
export type UseRBACPrioritizationSettingPageType = ReturnType<
  typeof useRBACPrioritizationSettingPage
>

export const BulkUploadRBAC = {
  pageID: 'e30da19e24e28f35bd367bee2931596c',
  elementID: {
    ViewPage: '805183771343c5ab2e4164e8d501567c',
    AccessAllLocations: '1db57aec4324c0ee30c50fffcee60875',
  },
} as const
export const useRBACBulkUploadPage = createUseRBAC(BulkUploadRBAC.elementID)
export type UseRBACBulkUploadPageType = ReturnType<typeof useRBACBulkUploadPage>
